// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2oEyM","header":"ClearentDisclaimer_header__3iGEc","inner":"ClearentDisclaimer_inner__2v9_3"};